import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogResult } from 'src/app/shared/dialogs/models';

@Component({
  templateUrl: './cancel-upload-dialog.component.html',
  styleUrls: ['./cancel-upload-dialog.component.scss'],
})
export class CancelUploadDialogComponent {
  constructor(private dialogRef: MatDialogRef<CancelUploadDialogComponent, DialogResult>) {}

  public close(): void {
    this.dialogRef.close({ done: false });
  }

  public done(): void {
    this.dialogRef.close({ done: true });
  }
}
